import React, { Component } from 'react';
import Map from './Map';
import { createRandomRoute } from '../../services/routeService';
import bg1 from '../../assets/images/b1.png'


export default class QuickWalk extends Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div>
                <div className="pageHeader" style={{ backgroundImage: `url(${bg1})` }}>
                    <h1>Quick Walk</h1>
                </div>
                <Map quickWalk={true} />
            </div>
        );
    }
}
